import { useMemo } from 'react';
import Accordion from "../../../views/UIelems/v2/Accordion";
import { contentfulToAccordion, formatCTAS, formatRichText } from "../../functions";
import { VariantTitle } from "../../components/VariantTitle";
import { PageSectionWrapper } from "../../components/PageSectionWrapper";
import { ProgressiveText } from "../../components/ProgressiveText";
import { CTAWrapper } from "../../components/CTA";

const DisplayText = ({ richText, displayType }) => {
	switch (displayType) {
		case "AS_PROGRESSIVE_TEXT":
			return <ProgressiveText richText={richText} />;
		case "NORMAL_TEXT":
			return <div>{richText}</div>;
		default:
			return null;
	}
};
export const AccordionPageSection = ({
	headerText,
	subtitle,
	accordion,
	ctas,
	variant,
	description,
	isStatic = false,
	siteStatus = null,
	displayTextType = "NORMAL_TEXT",
	sources,
	footnote,
	ctaTitle = "Still need help?",
	parsedFunctions
}) => {
	const accordionData = contentfulToAccordion(accordion, siteStatus, parsedFunctions);
	const formattedCTAs = useMemo(() => formatCTAS(ctas, siteStatus, isStatic), [ctas, siteStatus, isStatic]);

	const formattedDescription = formatRichText(description, siteStatus, [], {}, isStatic);
	const formattedFootnote = formatRichText(footnote, siteStatus, [], {}, isStatic);
	const accordionOnly = !headerText && !formattedDescription && formattedCTAs.length === 0;

	if (accordionData && accordionData.length === 0) {
		console.warn("Accordion data is empty or not provided.");
		return null;
	}

	return (
		<PageSectionWrapper variant={variant}>
			<VariantTitle
				parsedClasses={`md:hidden ${!displayTextType && "pb-12"}`}
				title={headerText}
				subtitle={subtitle}
			/>
			{formattedDescription && (
				<div className="md:hidden mt-12 mb-4">
					<DisplayText richText={formattedDescription} displayType={displayTextType} />
				</div>
			)}
			<div className={`flex flex-col md:flex-row-reverse gap-12 justify-center items-start ${accordionOnly ? "mt-0" : "mt-8 md:mt-0"}`}>
				{accordionData && <Accordion items={accordionData} width={accordionOnly && "w-full"} />}
				{!accordionOnly && <div className={`flex flex-col items-center md:items-start md:text-left m-auto mt-0 w-full md:w-[50%]`}>
					<VariantTitle
						parsedClasses={"hidden md:block !pb-8"}
						title={headerText}
						subtitle={subtitle}
					/>
					{formattedDescription && (
						<div className="hidden md:block">
							<DisplayText richText={formattedDescription} displayType={displayTextType} />
						</div>
					)}
					{formattedCTAs.length > 0 && (
						<span className="text-is2-yellow-500 text-md mb-4 mt-12">{ctaTitle}</span>
					)}
					<div className="flex flex-row gap-4">
						{formattedCTAs.map((cta, index) => (
							<CTAWrapper cta={cta} key={`cta-${index}`} />
						))}
					</div>
					{formattedFootnote && <div className="text-is2-gray-150 text-sm mt-10">{formattedFootnote}</div>}
					{sources && (
						<div className="flex flex-col w-full lg:pt-4">
							<h3 className="pt-4">Sources</h3>
							<p className="break-words text-sm">{sources}</p>
						</div>
					)}
				</div>}
			</div>
		</PageSectionWrapper>
	);
};
